import React from "react";
import { Link } from "react-router-dom";
import { FaTimes, FaUser, FaEdit, FaHome,FaWallet,FaChalkboardTeacher, FaStar, FaBook } from "react-icons/fa";



export default function StudentSidebar({ isOpen, toggleSidebar }) {
  return (
    <>
      {/* Sidebar */}
      <aside
        className={`fixed z-50 top-0 left-0 h-screen bg-white shadow-lg p-4 md:p-6 transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } w-64 md:w-64 overflow-y-auto`}
      >
        {/* Close button for mobile */}
        <div className="md:hidden flex justify-end mb-4">
          <button onClick={toggleSidebar} className="text-xl text-indigo-600">
            <FaTimes />
          </button>
        </div>

        <div className="text-center mb-8">
          <FaUser className="text-4xl mx-auto text-indigo-600" />
          <h2 className="text-lg font-semibold mt-2">Jane Doe</h2>
          <p className="text-sm text-gray-600">Student</p>
          <Link to="/student/edit-profile">
            <button className="mt-2 text-sm text-indigo-500 hover:underline flex items-center justify-center mx-auto">
              <FaEdit className="mr-1" /> Edit Profile
            </button>
          </Link>
        </div>

        <nav className="space-y-4">
          <Link
            to="/student/dashboard"
            className="flex items-center text-gray-700 hover:text-indigo-600"
          >
            <FaHome className="mr-2" /> Home
          </Link>
          <Link
            to="/student/join-class"
            className="flex items-center text-gray-700 hover:text-indigo-600"
          >
            <FaChalkboardTeacher className="mr-2" /> Join Class
          </Link>
          <Link
            to="/student/rate-teacher"
            className="flex items-center text-gray-700 hover:text-indigo-600"
          >
            <FaStar className="mr-2" /> Rate Teacher
          </Link>
          <Link
            to="/student/view-materials"
            className="flex items-center text-gray-700 hover:text-indigo-600"
          >
            <FaBook className="mr-2" /> Materials
          </Link>
  <Link
            to="/student/wallet"
            className="flex items-center text-gray-700 hover:text-indigo-600"
          
          >
            <FaWallet className="mr-2" /> Wallet
          </Link>


        </nav>
      </aside>
    </>
  );
}
